import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetPriceList(productId: number, sampleCardId: number, allPackages: boolean, packageId: number, discountApplied: boolean, discountId: number):
    Promise<AxiosResponse> {
    return API.get(`${config.serverUrl}/api/pricelist/${productId}/${sampleCardId}/${allPackages}/${packageId}/${discountApplied}/${discountId}`);
}

export function apiGetPriceListCsv(productId: number, sampleCardId: number, allPackages: boolean, packageId: number, discountApplied: boolean, discountId: number):
    Promise<AxiosResponse> {
    return API.get(`${config.serverUrl}/api/pricelistcsv/${productId}/${sampleCardId}/${allPackages}/${packageId}/${discountApplied}/${discountId}`,
        { responseType: 'blob' });
}
